/* global jQuery MktoForms2 */
/*
 * limit checkbox selection to 2
 */
(function ($) {

	"use strict";

	MktoForms2.whenReady(function () {
		$(document).on("alterFormValuesComplete", function () {
			$("[name=qSC19EngineerTeamChoice1]").on("change", function () {
				var numSelected = $("[name=qSC19EngineerTeamChoice1]:checked").length;
				if (numSelected === 2) {
					$("[name=qSC19EngineerTeamChoice1]:not(:checked)").attr("disabled", "disabled");
				} else if (numSelected < 2) {
					$("[name=qSC19EngineerTeamChoice1]").removeAttr("disabled");
				}
			});
		});
	});
}(jQuery));